export const AREAS = [
  { key: "famiglie", label: "Famiglie, genitorialità e cura", short: "Famiglie e cura" },
  { key: "bambini", label: "Bambine, bambini e crescita", short: "Bambine e bambini" },
  { key: "scuola", label: "Scuola e comunità educante", short: "Scuola e comunità" },
  { key: "relazioni", label: "Relazioni, parità e contrasto alla violenza", short: "Relazioni e parità" },
  { key: "comunita", label: "Comunità e territorio", short: "Comunità e territorio" },
];

// I tre filoni identitari + mappatura visiva.
// Ogni area del sito si aggancia a un filone; da lì il colore usato in card, filtri, badge.
export const FILONI = {
  comunita: {
    key: "comunita",
    label: "Comunità e reti tra pari",
    short: "Comunità",
    color: "#216B65",        // verde petrolio
    soft: "#E1EEEB",
    text: "#134240",
  },
  parita: {
    key: "parita",
    label: "Parità e libertà dalla violenza",
    short: "Parità",
    color: "#E85A6A",        // corallo
    soft: "#FBE3E6",
    text: "#8A2E37",
  },
  cnv: {
    key: "cnv",
    label: "CNV e relazioni educative",
    short: "CNV",
    color: "#E8A93C",        // giallo caldo
    soft: "#FBEFD4",
    text: "#7A5A18",
  },
};

// Associazione area -> filone (per colorare cards)
export const AREA_TO_FILONE = {
  famiglie: "cnv",
  bambini: "cnv",
  scuola: "cnv",
  relazioni: "parita",
  comunita: "comunita",
};

export const filoneOf = (project) => {
  if (project?.filone && FILONI[project.filone]) return FILONI[project.filone];
  const k = AREA_TO_FILONE[project?.area];
  return FILONI[k] || FILONI.comunita;
};

export const EVENT_STATUS = [
  { key: "bozza", label: "Bozza" },
  { key: "pubblicato", label: "Pubblicato" },
  { key: "iscrizioni_aperte", label: "Iscrizioni aperte" },
  { key: "completo", label: "Completo" },
  { key: "annullato", label: "Annullato" },
  { key: "concluso", label: "Concluso" },
];

export const PROJECT_STATUS = [
  { key: "bozza", label: "Bozza" },
  { key: "attivo", label: "Attivo" },
  { key: "in_pausa", label: "In pausa" },
  { key: "concluso", label: "Concluso" },
];

export const CATEGORIES = [
  { key: "news", label: "News" },
  { key: "imparato", label: "Cose che abbiamo imparato" },
  { key: "consiglia", label: "Vola Vola consiglia" },
  { key: "approfondimenti", label: "Approfondimenti" },
  { key: "territorio", label: "Dal territorio" },
  { key: "materiali", label: "Materiali e risorse" },
];

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("it-IT", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const formatDateShort = (iso) => {
  if (!iso) return { day: "", month: "" };
  const d = new Date(iso);
  const day = d.toLocaleDateString("it-IT", { day: "2-digit" });
  const month = d.toLocaleDateString("it-IT", { month: "short" }).replace(".", "");
  return { day, month };
};
